import { formatCurrency } from '@/app/utils/formatCurrency';
import { excessText } from './invoiceBalance';
import type { FundingPurpose } from '../types/agreements.types';

export interface AuthorisationFigures {
    total: string;
    available: string;
    claimed: string;
    excess: string;
}

const CONFIRM_REQUIRED_REASONS: Record<FundingPurpose, string> = {
    arrears: 'Confirm the amount to load into arrears before submitting.',
    pot_total: 'Confirm the amount to claim from the pot before submitting.',
};

const CANNOT_AUTHORISE_REASONS: Record<FundingPurpose, string> = {
    arrears: 'You cannot authorise loading this into arrears. Ask someone who can authorise it.',
    pot_total: 'You cannot authorise claiming this as the pot total. Ask someone who can authorise it.',
};

export const confirmRequiredReason = (purpose: FundingPurpose): string => CONFIRM_REQUIRED_REASONS[purpose];

export const cannotAuthoriseReason = (purpose: FundingPurpose): string => CANNOT_AUTHORISE_REASONS[purpose];

export const authorisationFigures = (
    selectionGross: number,
    cashPosition: number | undefined,
    excess: number,
): AuthorisationFigures => {
    const available = cashPosition === undefined ? 'Unavailable' : formatCurrency(cashPosition);
    return { total: formatCurrency(selectionGross), available, claimed: available, excess: excessText(excess) };
};

export const confirmationSentence = (
    purpose: FundingPurpose,
    figures: Pick<AuthorisationFigures, 'claimed' | 'excess'>,
): string =>
    purpose === 'pot_total'
        ? `I authorise claiming ${figures.claimed} from the pot. The dealer absorbs ${figures.excess} and the customer pays nothing more.`
        : `I authorise loading ${figures.excess} into arrears on this agreement`;
